import { render, staticRenderFns } from "./UserInputItems.vue?vue&type=template&id=23f9618b"
import script from "./UserInputItems.vue?vue&type=script&lang=js"
export * from "./UserInputItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports